import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import styles from './styles.js';
const useStyles = createUseStyles(styles, 'Frame');

const Frame = ({ url }) => {
    const classes = useStyles();
    return (
        <iframe className={classes.root} title="Marketing banner" scrolling="no" src={url}></iframe>
    );
};

export default memo(Frame);
